import { render } from "./SuccessfulGiftingModal.vue?vue&type=template&id=04843f62&scoped=true"
import script from "./SuccessfulGiftingModal.vue?vue&type=script&lang=js"
export * from "./SuccessfulGiftingModal.vue?vue&type=script&lang=js"

import "@/Common/Styles/giftNftModal.scss?vue&type=style&index=0&id=04843f62&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04843f62"]])

export default __exports__